(function () {

    var formApp = angular.module('formApp');

    // this controller is use executes the functionality in introduction page
    formApp.controller('toolsController',
        ['$scope', '$timeout', 'UtilityServices', 'DataServices',
        function ($scope, $timeout, UtilityServices, DataServices) {

            // this sets the page title
            document.title = 'Feedback Management System Tools page';

            var iosOrMobile = /iphone|ipod|ipad|mobile/.test(window.navigator.userAgent.toLowerCase());

            $scope.documentTemplates = [];
            DataServices.getDocumentTemplates()
                .then(function (data) {
                    $scope.allDocumentTemplatesByCategory = data;
                }, function (data) {
                    UtilityServices.showNotification(true, 'internalError');
                });

            var downloadDocumentTemplate = function (documentTemplate) {
                DataServices.getDocumentTemplateFile(documentTemplate.id)
                    .then(function (data) {
                        try {
                            var file = new Blob([data]);
                            saveAs(file, documentTemplate.fileName);
                        }
                        catch (e) {
                            UtilityServices.showNotification(true, 'internalError');
                        }
                    }, function (data) {
                        UtilityServices.showNotification(true, 'internalError');
                    });
            };
            $scope.onDocumentTemplateTouchend = function (documentTemplate) {
                $timeout(function () {
                    downloadDocumentTemplate(documentTemplate);
                }, 100);
            };
            $scope.onDocumentTemplateClick = function (documentTemplate) {
                if (!iosOrMobile) {
                    downloadDocumentTemplate(documentTemplate);
                }
            };
        }]);
}());